<template>
  <exo-help-dialog title="Optimisation type" margin="mt-6 ml-2">
    <table>
      <tbody>
        <tr>
          <td>ΔV &nbsp;</td>
          <td>
            Minimise the ΔV and thus the propellant needed to fulfill the
            mission.
          </td>
        </tr>
        <tr>
          <td>ΔAOL &nbsp;</td>
          <td>Maximise the relative* phasing angle.</td>
        </tr>
        <tr>
          <td>ΔT &nbsp;</td>
          <td>Minimise the duration of the mission.</td>
        </tr>
      </tbody>
    </table>
    <br />
    *ΔAOL must be understood as a relative mean argument of latitude phasing
    with respect to the initial orbit.
  </exo-help-dialog>
</template>

<script>
export default {
  name: 'tooltipOrbitPhasingOptimizationType'
}
</script>
